import type { PrizeType } from '../../services/prizes';

export const PRIZE_OPTIONS: { type: PrizeType; label: string; icon: string }[] = [
  { type: 'pick_next_song', label: 'Pick Next Song', icon: '🎵' },
  { type: 'auto_queue_bypass', label: 'Queue Bypass', icon: '⚡' },
  { type: 'shoutout', label: 'Shoutout', icon: '📣' },
  { type: 'custom', label: 'Custom', icon: '🎁' },
];

export function prizeNeedsText(prizeType: PrizeType): boolean {
  return prizeType === 'custom' || prizeType === 'shoutout';
}
